import * as types from '../actions/action-types';

const initialState = {
  user: false
};

const userReducer = (state = initialState, action) => {
  
  switch (action.type) {
    case types.SET_USER_DATA:
      return { ...state, user: action.user };
    default:
      return state
  }
};

export default userReducer;